import { getApps, initializeApp } from "firebase/app";
import { store } from ".";
import { setFirebaseInitialized, setFirstCheckDone, setUser } from "./userSlice";
import { IS_CYPRESS, STORAGE_KEY_LAST_ACTIVITY, STORAGE_KEY_ORG_TIMEOUT_SECONDS } from "../envVariables";
import { getAuth, inMemoryPersistence, setPersistence, signOut } from "firebase/auth";
import { getAnalytics, logEvent } from "firebase/analytics";
import { sentryLog } from "../tools/sentry";

export function getFirebaseApp() {
  return getApps().find((a) => a.name === "main");
}

export function initializeFirebase() {
  const dispatch = store.dispatch;

  if (!getFirebaseApp()) {
    const firebaseConfig = {
      apiKey: store.getState().discovery.firebase.apiKey,
      authDomain: store.getState().discovery.firebase.authDomain,
      projectId: store.getState().discovery.firebase.projectId,
      measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID,
      appId: import.meta.env.VITE_FIREBASE_APP_ID,
      storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
    };
    initializeApp(firebaseConfig, "main");
  }

  dispatch(setFirebaseInitialized(true));

  const app = getFirebaseApp();

  if (IS_CYPRESS) {
    setPersistence(getAuth(), inMemoryPersistence);
  }

  getAuth(app).onAuthStateChanged(async (user) => {
    const wasFirstCheck = !store.getState().user.firstCheckDone;
    if (wasFirstCheck) {
      dispatch(setFirstCheckDone(true));

      if (user) {
        const lastActiveSec = Math.round(Number(localStorage.getItem(STORAGE_KEY_LAST_ACTIVITY) || "0") / 1000);
        const currentSec = Math.round(new Date().getTime() / 1000);
        const differenceSec = currentSec - lastActiveSec;
        const orgTimeoutSec = Number(localStorage.getItem(STORAGE_KEY_ORG_TIMEOUT_SECONDS) || String(15 * 60));
        const oneHourSec = 60 * 60;
        const thresholdSec = orgTimeoutSec > oneHourSec ? orgTimeoutSec : oneHourSec;

        if (differenceSec > thresholdSec) {
          sentryLog("sign out automatically after auto log in", {
            "data.lastActiveSec": lastActiveSec,
            "data.currentSec": currentSec,
            "data.differentSec": differenceSec,
            "data.orgTimeoutSec": orgTimeoutSec,
            "data.thresholdSec": thresholdSec,
            "user.email": user.email,
            "user.name": user.displayName,
          });
          await signOut(getAuth(app));
          return;
        }
      }
    }

    if (!user) {
      dispatch(setUser({ user: null, extra: { type: "none" } }));
      return;
    }

    if (wasFirstCheck && store.getState().user.provider === "aws") {
      await signOut(getAuth(app));
      return;
    }

    dispatch(
      setUser({
        user: {
          email: user.email || "",
          name: user.displayName || "",
          photoUrl: user.photoURL || "",
          uid: user.uid,
        },
        extra: {
          type: "user",
        },
      }),
    );

    logEvent(getAnalytics(app), "login");
  });
}
